import React from "react";
import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

interface AppSwitchProps extends SwitchProps {
  outlined?: boolean;
}

const AppSwitch = styled(
  (props: AppSwitchProps) => {
    const { outlined, ...other } = props;
    return (
      <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...other}
      />
    );
  },
  {
    shouldForwardProp: (prop) => prop !== "outlined",
  }
)<AppSwitchProps>(({ theme, outlined, checked }) => ({
  width: 42,
  height: 26,
  padding: 0,
  display: "flex",

  "&:active .MuiSwitch-thumb": {
    width: 22,
  },

  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",

      "& .MuiSwitch-thumb": {
        backgroundColor: "#fff",
        width: 22,
        height: 22,
      },

      "& + .MuiSwitch-track": {
        opacity: 1,
        border: 0,
      },
    },
    ...(!checked &&
      outlined && {
        transform: "translateX(2px)",
      }),
  },

  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgba(0, 35, 11, 0.2)",
    width: 22,
    height: 22,
    borderRadius: 11,
    transition: theme.transitions.create(
      ["width", "background-color", "transform"],
      {
        duration: 200,
      }
    ),
    ...(outlined && {
      backgroundColor: "#5C5C5C",
      boxShadow: "none",
      width: 14, 
      height: 14,
      marginTop: checked ? 0 : 4,
    }),
  },

  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#39393D" : "#E9E9EA",
    boxSizing: "border-box",
    ...(outlined && {
      border: "2px solid #5C5C5C",
      backgroundColor: "#E0E0E0",
      opacity: 1,
    }),
  },
}));

export default AppSwitch;
